export default __webpack_public_path__ + "static/media/Giftr-Seller-Center-Logo.e0b4f388.svg";